/* eslint-disable react/destructuring-assignment */
import { fetchServicesNews } from 'features/services/business/Services.api';
import { DryingHerbsLayout } from 'features/services/components/DryingHerbsLayout/DryingHerbsLayout.component';
import { GetStaticProps } from 'next';
import { Content } from 'pleinchamp-api-client';
import React, { createContext } from 'react';
import { usePlcApiCall } from '@api/business/api.hook';
import { useLocation } from '@meteo/business/LocationSelector.hook';
import { useSelectNewCity } from '@meteo/business/meteo.utils';
import { City, StandardCity } from '@meteo/types';
import { formatPropsForStatic } from '@utils/api.utils';
import { defaultNamespaces } from '@utils/strings';
import { PlcNextPage, PlcPageContextProps } from 'features/business/app.types';

interface Props {
  news: Content[];
}

type CityContextProp = {
  data?: StandardCity;
  isValidating: boolean;
  error?: string;
  setData: (data?: City) => void;
};

export const DryingHerbsContext = createContext<PlcPageContextProps<Props> & { city: CityContextProp }>({
  city: { isValidating: false, setData: () => {} },
  news: { isValidating: false },
});

const DryingHerbsPage: PlcNextPage<Partial<Props>> = props => {
  const { selectedCity, onSelectNewCity } = useSelectNewCity();
  const { city, isGeolocationLoading, geolocationError } = useLocation(selectedCity);
  const news = usePlcApiCall(fetchServicesNews, [], {
    initialData: props.news,
  });

  return (
    <DryingHerbsContext.Provider
      value={{
        city: {
          data: city,
          error: geolocationError,
          isValidating: isGeolocationLoading,
          setData: onSelectNewCity,
        },
        news,
      }}
    >
      <DryingHerbsLayout />
    </DryingHerbsContext.Provider>
  );
};

export const getStaticProps: GetStaticProps = async () => {
  const pageDefaultState = {
    namespacesRequired: [...defaultNamespaces, 'services'],
  };

  const props = await Promise.all([fetchServicesNews()])
    .then(([news]) => ({ ...pageDefaultState, news }))
    .catch(() => pageDefaultState);

  return formatPropsForStatic(props);
};

export default DryingHerbsPage;
